module.exports = __webpack_public_path__ + "img/ring_y_o_1_1.b0b01861.png";